document.addEventListener("DOMContentLoaded", function () {
  const handleUserInteraction = () => {
    
    const gtagScript = document.createElement("script");
    gtagScript.src = `https://www.googleoptimize.com/optimize.js?id=GTM-W5T3ZCQ`; // Replace with your GTAG ID
    gtagScript.async = true;
    gtagScript.id = "gtag-script";
    document.head.appendChild(gtagScript);

    // Google Tag Manager
    const inlineGTMScript = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-M94KFWD');
    `;
    const inlineGTMScriptObj = document.createElement("script");
    inlineGTMScriptObj.id = "gtag-init";
    inlineGTMScriptObj.textContent = inlineGTMScript;
    document.head.appendChild(inlineGTMScriptObj);

    // Global site tag (gtag.js) - Google Ads: 1Z2CT9RE1S
    const globalTagScript = document.createElement("script");
    globalTagScript.src = `https://www.googletagmanager.com/gtag/js?id=G-1Z2CT9RE1S`;
    globalTagScript.async = true;
    globalTagScript.id = "global-tag-script";
    document.head.appendChild(globalTagScript);

    // Page hiding snippet (recommended)
    const inlineGlobalTagScript = `
      window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-1Z2CT9RE1S', {'allow_enhanced_conversions': true});
    `;
    const inlineGlobalTagScriptObj = document.createElement("script");
    inlineGlobalTagScriptObj.id = "phs-init";
    inlineGlobalTagScriptObj.textContent = inlineGlobalTagScript;
    document.head.appendChild(inlineGlobalTagScriptObj);


     // Clarity
    const inlineClarityScript = `
         (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "qpgkouupt6");
    `;
    const inlineClarityScriptObj = document.createElement("script");
    inlineClarityScriptObj.id = "clarity-init";
    inlineClarityScriptObj.textContent = inlineClarityScript;
    document.head.appendChild(inlineClarityScriptObj);

    // CustomerLabs Tag
    const inlineCustomerLabsScript = `
        !function(t,e,r,c,a,n,s){t.ClAnalyticsObject=a,t[a]=t[a]||[],t[a].methods=["trackSubmit","trackClick","pageview","identify","track", "trackConsent"],t[a].factory=function(e){return function(){var r=Array.prototype.slice.call(arguments);return r.unshift(e),t[a].push(r),t[a]}};for(var i=0;i<t[a].methods.length;i++){var o=t[a].methods[i];t[a][o]=t[a].factory(o)};n=e.createElement(r),s=e.getElementsByTagName(r)[0],n.async=1,n.crossOrigin="anonymous",n.src=c,s.parentNode.insertBefore(n,s)}(window,document,"script","https://cdn.js.customerlabs.co/cl6254w0oodo6h.js","_cl");_cl.SNIPPET_VERSION="2.0.0"
    `;
    const inlineCustomerLabsScriptObj = document.createElement("script");
    inlineCustomerLabsScriptObj.id = "customer-labs-init";
    inlineCustomerLabsScriptObj.textContent = inlineCustomerLabsScript;
    document.head.appendChild(inlineCustomerLabsScriptObj);
    

    // Remove event listeners after execution
    window.removeEventListener("click", handleUserInteraction);
    window.removeEventListener("scroll", handleUserInteraction);
    window.removeEventListener("keydown", handleUserInteraction);
    window.removeEventListener("mousemove", handleUserInteraction);
    window.removeEventListener("touchstart", handleUserInteraction);
    window.removeEventListener("touchmove", handleUserInteraction);
  };

  // Add event listeners to detect user interaction
  window.addEventListener("click", handleUserInteraction);
  window.addEventListener("scroll", handleUserInteraction);
  window.addEventListener("keydown", handleUserInteraction);
  window.addEventListener("mousemove", handleUserInteraction);
  window.addEventListener("touchstart", handleUserInteraction);
  window.addEventListener("touchmove", handleUserInteraction);

  // Clean up event listeners when no longer needed
  window.addEventListener("beforeunload", () => {
    window.removeEventListener("click", handleUserInteraction);
    window.removeEventListener("scroll", handleUserInteraction);
    window.removeEventListener("keydown", handleUserInteraction);
    window.removeEventListener("mousemove", handleUserInteraction);
    window.removeEventListener("touchstart", handleUserInteraction);
    window.removeEventListener("touchmove", handleUserInteraction);
  });
});